import { createElement, ReactElement, ReactNode } from "react";

type TitleProps = {
  as?: string,
  children?: ReactNode
} & ReactElement['props'] & React.HTMLAttributes<HTMLElement>;

export default function Title({ as = 'h1', children = [], ...props }: TitleProps): ReactElement {
  return createElement(as, props, children);
}
